import React from 'react';
export function StickyAlertBar() {
  const marqueeText = '¡SOLO POR HOY +8 CURSOS GRATIS!  ⚡  ¡SOLO POR HOY +8 CURSOS GRATIS!  ⚡  ¡SOLO POR HOY +8 CURSOS GRATIS!  ⚡  ¡SOLO POR HOY +8 CURSOS GRATIS!  ⚡  ';
  return <a href="https://carlosponte.com/cart/clear?return_to=/cart/add?id=56937498575173&quantity=1" className="fixed top-0 left-0 right-0 z-50 bg-[#FF6B00] cursor-pointer select-none shadow-lg overflow-hidden block" onPointerDown={() => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    } catch {}
  }} data-id="element-342">
      <div className="py-2 whitespace-nowrap animate-[marqueeScroll_12s_linear_infinite]" data-id="element-343">
        <span className="text-white font-extrabold text-sm md:text-base uppercase tracking-wide inline-block" style={{
        textShadow: '0 1px 3px rgba(0,0,0,0.5)'
      }} data-id="element-344">
          {marqueeText}
          {marqueeText}
        </span>
      </div>
    </a>;
}